import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "modal modal-open" }
const _hoisted_2 = { class: "sticky -top-6 z-10 flex justify-center bg-white p-5" }
const _hoisted_3 = {
  key: 0,
  class: "text-center text-4xl font-semibold text-blue-1 sm:mt-0 lg:text-5xl"
}

import {
  XMarkIcon,
} from '@heroicons/vue/24/outline';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComponentModal',
  props: {
  boxClass: {
    type: String,
    default: 'max-w-screen-lg',
  },
  title: {
    type: String,
    default: '',
  },
},
  emits: ["close"],
  setup(__props) {







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["sidebar modal-box", __props.boxClass])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (__props.title)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(__props.title), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-circle absolute right-0 p-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_unref(XMarkIcon))
        ])
      ]),
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})